// extracted by mini-css-extract-plugin
export default {"pointerCursor":"pointerCursor__uxnId","scrolledDown":"scrolledDown__Gwa0W","scrolledUp":"scrolledUp__TNcdm"};